import store from '@/store';
import {QuoteAddress} from '@/store/models';
import {findCountryRegionByCode, findRegions} from './regionFinder';

const API_KEY = store.state.options.gmap.api_key;
const LIBRARIES = 'places';

let initialized = !!window.google;
let resolveProm: any;
let rejectProm: any;

const promise: any = new Promise((resolve, reject) => {
    resolveProm = resolve;
    rejectProm = reject;
});

export default function init(): Promise<typeof google> {
    if (initialized) {
        return promise;
    }

    initialized = true;
    window.gmapsCallback = () => resolveProm(window.google);

    const script = document.createElement('script');
    script.async = true;
    script.defer = true;
    script.src = `https://maps.googleapis.com/maps/api/js?key=${API_KEY}&callback=gmapsCallback&libraries=${LIBRARIES}`;
    script.onerror = rejectProm;
    const headEl = document.querySelector('head') as HTMLElement;
    headEl.appendChild(script);

    return promise;
}

export function placeFoundCallback(place: google.maps.places.PlaceResult, address: QuoteAddress) {
    if (place.address_components && place.address_components.length > 0) {
        const countryRegions = findRegions(address.country_id);
        const street = {
            number: '',
            address: '',
        };
        const city = '';
        place.address_components.forEach((addressComponent) => {
            const addressType = addressComponent.types[0];
            switch (addressType) {
                case 'locality':
                    address.city = addressComponent.long_name;
                    break;
                case 'street_number':
                    street.number = addressComponent.long_name;
                    break;
                case 'route':
                    street.address = addressComponent.long_name;
                    break;
                case 'postal_code':
                    address.postcode = addressComponent.long_name;
                    break;
                case 'administrative_area_level_2':
                    if (address.country_id && addressComponent.short_name) {
                        const regionFound = findCountryRegionByCode(address.country_id, addressComponent.short_name);
                        if (regionFound && regionFound.region_id) {
                            address.region_id = regionFound.region_id;
                        } else if (!countryRegions) {
                            address.region = addressComponent.long_name;
                        }
                    }

                    break;
                default:
                    break;
            }
        });

        if (street.address) {
            address.street = [street.address];
        }
        if (city) {
            address.city = city;
        }
    }

    return address;
}
